var React = require('react');

function ArrowGalleryIcon (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,"\n      .arrow-gallery-svg {\n        fill: #8c8c8c;\n        fill-rule: evenodd;\n      }\n    ")),React.createElement("path",{"id":"Rounded_Rectangle_54","data-name":"Rounded Rectangle 54","className":"arrow-gallery-svg","d":"M768.015,637.988h-8.028l4.014-6ZM763,638h2v3a1,1,0,0,1-2,0v-3Z","transform":"translate(-760 -632)","key":1})]);
}

ArrowGalleryIcon.defaultProps = {"width":"8","height":"10","viewBox":"0 0 8 10"};

module.exports = ArrowGalleryIcon;

ArrowGalleryIcon.default = ArrowGalleryIcon;
